import {fromJS, Map} from 'immutable';
import activeUsersOverviewActions from '../../actions/fortnite-game/activeUsersOverview.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {DataItem} from './types';

export interface ActiveUsersOverviewState {
    peak: {
        all: DataItem;
        today: DataItem;
    };
    avg: {
        all: DataItem;
        today: DataItem;
    };
}

export const DEFAULT_STATE = fromJS({
    peak: {
        all: {
            amount: 0,
            loading: false
        },
        today: {
            amount: 0,
            trend: 0,
            loading: false
        }
    },
    avg: {
        all: {
            amount: 0,
            loading: false
        },
        today: {
            amount: 0,
            trend: 0,
            loading: false
        }
    }
});

export const activeUsersOverview = (state: Map<string, any> = DEFAULT_STATE, action) => {
    const {data, error, since, value} = action.payload || {};

    switch (action.type) {
        case activeUsersOverviewActions.TYPES.GET_ACTIVE_USERS_OVERVIEW: {
            return state.merge({
                [value]: state.get(value).merge({
                    [since]: state
                        .get(value)
                        .get(since)
                        .merge({
                            error: undefined,
                            loading: true
                        })
                })
            });
        }

        case activeUsersOverviewActions.TYPES.GET_ACTIVE_USERS_OVERVIEW_COMPLETE: {
            return state.merge({
                [value]: state.get(value).merge({
                    [since]: state
                        .get(value)
                        .get(since)
                        .merge({
                            ...data,
                            loading: false
                        })
                })
            });
        }

        case activeUsersOverviewActions.TYPES.GET_ACTIVE_USERS_OVERVIEW_FAILED: {
            return state.merge({
                [value]: state.get(value).merge({
                    [since]: state
                        .get(value)
                        .get(since)
                        .merge({
                            error,
                            loading: false
                        })
                })
            });
        }

        default:
            return state;
    }
};

export default dieselReducer('activeUsersOverview', activeUsersOverview);
